import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RewardsComponent } from '@app/screens/rewards/rewards.component';
import { GiftCardsComponent } from '@app/screens/gift-cards/gift-cards.component';
import { ActivitySectionDirective, UserActivityClickTrackingDirective } from '@core';
import { SpecialTabComponent } from '@app/screens/special/special.component';
import { MoreComponent } from '@app/screens/more/more.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { shareReplay } from 'rxjs';

type State = 'main' | 'rewards' | 'promo' | 'gift' | 'more';

@Component({
  selector: 'app-service-center-sections',
  templateUrl: './service-center-sections.component.html',
  styleUrls: ['./service-center-sections.component.scss'],
  imports: [
    TranslateModule,
    RewardsComponent,
    GiftCardsComponent,
    SpecialTabComponent,
    ActivitySectionDirective,
    UserActivityClickTrackingDirective,
    MoreComponent,
  ],
  animations: [
    trigger('InOutAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms ease-in-out', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('400ms ease-in-out', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCenterSectionsComponent {

  public readonly currentLanguage = toSignal(this.translate.onLangChange.pipe(
    map((event) => event.lang),
    shareReplay(1),
  ), { initialValue: this.translate.currentLang ?? this.translate.defaultLang });

  public state = signal<State>('main');

  constructor(
    private readonly translate: TranslateService,
  ) {}

  public setState(state: State): void {
    this.state.set(state);
  }
}
